var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/postcss-loader/src/index.js??postcss!../../../../node_modules/resolve-url-loader/index.js??ref--4-oneOf-5-2!../../../../node_modules/sass-loader/lib/loader.js??ref--4-oneOf-5-3!./ErrorBoundary.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = (linkTag) => {
            if (window.MD && window.MD.styleRepository) {
              window.MD.styleRepository.registerStyleTag(linkTag);
            } else {
              console.warn(
                "[MD] styleRepository not available. Adding to document.head"
              );
              document.head.appendChild(linkTag);
            }
          };
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};